import React, { useEffect, useState } from "react";

const Testimonialabout = () => {
  const testimonials = [
    {
      name: "Mr. Rajesh Patil",
      position: "Business Traveler",
      image: "/images/testimonial/pic1.jpg",
      review:
        "Excellent cab service from Pune to Mumbai. Garud Cab Service provided a clean vehicle, a professional driver, and a comfortable journey.",
    },
    {
      name: "Ms. Pooja Sharma",
      position: "Family Traveler",
      image: "/images/testimonial/pic2.jpg",
      review:
        "Garud Cab Service made our trip smooth and stress-free. The booking process was easy, the driver was polite, and the service was reliable.",
    },
    {
      name: "Mr. Suresh Kulkarni",
      position: "Regular Customer",
      image: "/images/testimonial/pic3.jpg",
      review:
        "I highly recommend Garud Cab Service for family and business travel. The cars are well maintained and the drivers are punctual and professional.",
    },
    {
      name: "Ms. Neha Joshi",
      position: "Happy Passenger",
      image: "/images/testimonial/pic1.jpg",
      review:
        "A very comfortable and safe travel experience. Garud Cab Service provided excellent customer support and made our journey enjoyable.",
    },
    {
      name: "Mr. Akash Deshmukh",
      position: "Outstation Traveler",
      image: "/images/testimonial/pic2.jpg",
      review:
        "Great service at an affordable price. The pickup was exactly on time and the entire journey was comfortable and convenient.",
    },
    {
      name: "Ms. Riya Sharma",
      position: "Frequent Traveler",
      image: "/images/testimonial/pic3.jpg",
      review:
        "Garud Cab Service is a trusted travel partner. Clean cars, courteous drivers, reasonable pricing, and excellent service every time.",
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const visibleTestimonials = [
    testimonials[current],
    testimonials[(current + 1) % testimonials.length],
    testimonials[(current + 2) % testimonials.length],
  ];

  return (
    <div className="section-full py-3 site-bg-dark twm-testimonial-section-wrap">
      <div className="container">

        {/* ================= HEADING ================= */}
        <div className="row">
          <div className="col-lg-6">
            <div className="section-head left">

              <div className="twm-sm-title left text-dark">
                Testimonials
              </div>

              <h2 className="twm-large-title site-text-white text-dark">
                What Our Customers Say
              </h2>

            </div>
          </div>
        </div>

        {/* ================= TESTIMONIALS ================= */}
        <div className="section-content">
          <div className="row">

            {visibleTestimonials.map((item, index) => (
              <div
                className="col-lg-4 col-md-6 mb-4"
                key={`${item.name}-${index}`}
              >
                <div className="twm-testimonial2 drk-view">

                  {/* ================= CUSTOMER ================= */}
                  <div className="twm-testimonial-head">

                    {/* Customer Image */}
                    {/*
                    <div className="media-pic">
                      <img
                        src={item.image}
                        alt={item.name}
                      />
                    </div>
                    */}

                    <div className="twm-author-detail">

                      <h3 className="twm-title text-dark">
                        {item.name}
                      </h3>

                      <div className="twm-position text-dark">
                        {item.position}
                      </div>

                    </div>
                  </div>

                  {/* ================= REVIEW ================= */}
                  <div className="twm-testimonial-detail">

                    <p className=" text-whitee">
                      {item.review}
                    </p>

                    {/* Star Rating */}
                    <div className="twm-rating-wrap">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span key={star}>
                          <i className="fa fa-star"></i>
                        </span>
                      ))}
                    </div>

                  </div>

                  {/* ================= QUOTE ================= */}
                  <div className="twm-quote-icon">
                    <img
                      src="/images/quote.png"
                      alt="Quote"
                    />
                  </div>

                </div>
              </div>
            ))}

          </div>
        </div>

      </div>
    </div>
  );
};

export default Testimonialabout;
